/* istanbul ignore file */
import { HTTP } from 'framework/api';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';

export const useHandleError = () => {
  const { addMessage } = useMessageService();

  const handleError = (error: Response) => {
    switch (error.status) {
      case HTTP.SERVICE_UNAVAILABLE:
        addMessage(new ErrorMessage('Service is temporarily unavailable. Please refresh the page and try again later'));
        break;
      default:
        throw error;
    }
  };

  return { handleError };
};
